import { Message } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { useCart } from "./cart.context";

export function CartItemLimit() {
	const { t } = useTranslation(["common", "cart"]);
	const { remainingItemsLimit } = useCart();

	if (remainingItemsLimit > 0) return null;

	return (
		<div className="px-3 md:px-6 pt-4">
			<Message variant="info">{t("cart:limit.info")}</Message>
		</div>
	);
}
